import React, {useEffect, useState} from 'react';
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
import { Container } from "reactstrap";
import {
    Table,
    Row,
    Col,
    Card,
    CardBody,
    CardTitle,
    CardSubtitle,
    UncontrolledTooltip,
    CardText,
    Button,
    Badge,
    Form,
    Input,
    InputGroup,
  } from "reactstrap"
  import { Link } from "react-router-dom"
  //Import Flatepicker
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import Select from 'react-select';
import * as url from "helpers/url_helper";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import PropTypes from "prop-types";


import axios from 'axios';
import { HRConfig, formatDate, TOAST_OPTIONS } from "../../helpers/backend_helper"
import { HRAPPROVALS } from 'helpers/url_helper';

import toastr from "toastr";
import "toastr/build/toastr.min.css";

import LoadingOverlay from 'react-loading-overlay';
import ClimbingBoxLoader from 'react-spinners/ClimbingBoxLoader'

    const LeaveApprovals = () => {

      toastr.options = TOAST_OPTIONS;
      const [approvals, setApprovals] = useState([]);
      const [isloading, setIsloading] = useState(false);

      useEffect(() => {
        if (localStorage.getItem("authMildUser")) {
          const obj = JSON.parse(localStorage.getItem("authMildUser"));
          const CompanyID = obj.activeCompany;
          setIsloading(true)
          axios.get(`${HRAPPROVALS}?$filter=ApproverID eq '${obj.username}' and Status eq 'Created' and DocumentType eq 'Leave Request' &company='${CompanyID}'`, HRConfig).then((r)=>{
            setApprovals(r.data.value)
            setIsloading(false)
          }).catch((e)=>{
            console.error(`Error fetching approvals ${JSON.stringify(e)}`);
            setIsloading(false)
          })
        }
        
        
      },[]);
      
      const handleFilter = (e) => {
        e.preventDefault();

        let obj1 = JSON.parse(localStorage.getItem("authMildUser"));
        let NavUserName = obj1.nav_username;

        const dateRange = document.getElementsByClassName('filterDate')[0]._flatpickr.selectedDates;
        const startDate = formatDate(dateRange[0]);
        const endDate = formatDate(dateRange[1]);
        const stat = document.getElementsByClassName('filterStatus')[0].value;
        const docType = document.getElementsByClassName('filterDocumentType')[0].value;
        let url = url.HRAPPROVALS ;
        let urlParams = '';
     
        if(stat != ''){
          urlParams = urlParams.concat( ` and Status eq '${stat}' `);
        }
        if(docType = 'Leave Request'){
            urlParams = urlParams.concat( ` and DocumentType eq '${docType}' `);
          }

        if(dateRange.length > 0){
          urlParams = urlParams.concat(` and ( DateTimeSentforApproval ge ${startDate} and DateTimeSentforApproval le ${endDate} )`);
        }
        if(urlParams != ''){
          url = url + "?$filter=ApproverID eq '"+ NavUserName +"'" + urlParams //.substr(5);
        }else{
            url = url + "?$filter=ApproverID eq '"+ NavUserName  +"'"
        }
        console.log(url)
    
        axios.get(url, HRConfig).then(function(response){    setApprovals(response.data.value);    })
      }
    
      const { SearchBar } = Search;
      const columns = [
      {
        dataField: 'DocumentNo',
        text: 'Document No',
        sort: true,
        formatter: noFormatter
      },
      {
        dataField: 'Requestorname',
        text: 'Requestor Name',
        sort: true
      }, 
      /*{
        dataField: 'approvalCode',
        text: 'ApprovalCode',
        sort: true
      }, 
      
      {
        dataField: 'employeeNo',
        text: 'No',
        sort: true
      }, 
      {
        dataField: 'senderID',
        text: 'Sender',
        sort: true
      },
      {
        dataField: 'approverID',
        text: 'Approver',
        sort: true
      },
      */
      {
        dataField: 'DateTimeSentforApproval',
        text: 'Date Sent',
        sort: true
      },
      /*{
        dataField: 'LastDateTimeModified',
        text: 'Last Modified',
        sort: true
      }, */
      {
        dataField: 'Status',
        text: 'Status',
        sort: true,
        formatter: statusFormatter
      },
      {
        dataField: "action",
        isDummyField: true,
        text: "Action",
        formatter: actionFormatter
      }];

      const defaultSorted = [{
        dataField: 'documentNo',
        order: 'desc'
      }];

      function noFormatter(cellContent, row){
        return(
          <strong>{cellContent}</strong>
        )
      }

      function actionFormatter(cellContent, row){
        return(
          <>
          <div className="d-flex gap-3">
          
          {(row.DocumentNo.substring(0, 2) == 'LP') && (row.Status == 'Created') && (
          <Link
              to={`/approve-leave-plan/${row.documentNo}/${row.SystemId}`}
              className="text-primary"
            >
              <i className="mdi mdi-alarm-panel-outline font-size-18" id="detailstooltip" />
              <UncontrolledTooltip placement="top" target="detailstooltip">
                Details
              </UncontrolledTooltip>
            </Link>
            
            )}
            {(row.DocumentNo.substring(0, 2) == 'LR') && (row.Status == 'Created') && (
            
            <Link
              to={`/approve-leave-request/${row.DocumentNo}/${row.SystemId}`}
              className="text-primary"
            >
              <i className="mdi mdi-alarm-panel-outline font-size-18" id="detailstooltip" />
              <UncontrolledTooltip placement="top" target="detailstooltip">
                Details
              </UncontrolledTooltip>
            </Link>
            )}
            {(row.DocumentNo.substring(0, 2) == 'LV') && (row.Status == 'Created') && (
            
            <Link
              to={`/approve-leave-request/${row.DocumentNo}/${row.SystemId}`}
              className="text-primary"
            >
              <i className="mdi mdi-alarm-panel-outline font-size-18" id="detailstooltip" />
              <UncontrolledTooltip placement="top" target="detailstooltip">
                Details
              </UncontrolledTooltip>
            </Link>
            )}
            
          </div>
        </>
        )
      }
      function statusFormatter(cellContent, row) {
        if (row.Status == "Canceled") {
          return (
            <div>
                <Badge className="me-2 bg-danger">
                { cellContent }
                </Badge>
            </div>
          );
        }else if (row.Status == "Approved"){
          return (
            <div>
                <Badge className="me-2 bg-success">
                { cellContent }
                </Badge>
            </div>
          );
        }else if (row.Status == "Created"){
            return (
              <div>
                  <Badge className="me-2 bg-warning">
                  { cellContent }
                  </Badge>
              </div>
            );
          }else{
          return (
            <div>
                <Badge className="me-2 bg-dark">
                { cellContent }
                </Badge>
            </div>
          );
        }
      }
      
        

   
        return (
            <>
             <LoadingOverlay
                active={isloading}
                spinner={<ClimbingBoxLoader />}
                text='Please wait...'
                >
                <div className="page-content">
                    <MetaTags>
                    <title>Leave Approvals | BRIDGE</title>
                    </MetaTags>
                    <Container fluid={true}>
                        <Breadcrumbs title="Human Resource Management" breadcrumbItem="Leave Approvals" />

               
                    
                        <Row>
                            <Col lg={12}>
                              <Card>
                                <CardBody>
                                  <CardTitle>Leave Approvals</CardTitle>
                                  <CardSubtitle className="mb-3">
                                    
                                  </CardSubtitle>

                                  {(approvals.length > 0)?(
                                  <ToolkitProvider
                                      keyField="DocumentNo"
                                      data={ approvals }
                                      columns={ columns }
                                      search
                                    >
                                      { toolkitProps => (
                                          <React.Fragment>
                                            <Row className='mb-5'>
                                              <Col lg={8} className='mb-2'>
                                                <div  className="rounded bg-light d-grid gap-2">
                                                  <SearchBar {...toolkitProps.searchProps} className="form-control bg-transparent border-0 searchTm m-0" />
                                                </div>
                                              </Col>
                                        
                                              <Col lg={4}> 
                                              <div className="d-grid gap-2">
                                                  
                                                </div>
                                              </Col>
                                            </Row>
                                            <Row>
                                              <Col xl="12">
                                                <div className="table-responsive">
                                            
                                                <BootstrapTable 
                                                  keyField='DocumentNo' 
                                                  data={ approvals } 
                                                  columns={ columns } 
                                                  striped
                                                  hover
                                                  condensed
                                                  bordered={ false }
                                                  noDataIndication="No Records" 
                                                  defaultSorted={ defaultSorted }
                                                  classes={ "table align-middle table-nowrap table-check" }
                                                    {...toolkitProps.baseProps}
                                                  />
                                            </div>
                                            </Col>
                                            </Row>
                                            </React.Fragment>
                                            
                                      )
                                    }
                                  </ToolkitProvider>
                                  ):(
                                    <Row className="d-flex justify-content-center">
                                        <Col lg={8} >
                                        
                                            
                                            <div className="text-center">
                                                <div className="mb-4">
                                                <i className="mdi mdi-check-circle-outline text-success display-4" />
                                                </div>
                                                <div>
                                                <h5>No pending approvals</h5>
                                                <p className="text-muted">
                                                        
                                                </p>
                                                </div>
                                            </div>
                                            
                                        </Col>
                                    </Row>
                                  )}

                                  
                                  
                                </CardBody>
                              </Card>
                            </Col>
                          </Row>
                        
                           

                    </Container>
                </div>
                </LoadingOverlay>
            </>
        );
                  
    }

export default LeaveApprovals;